import { Box, styled } from '@creditas-ui/react'
import React from 'react'

const CardContentFeedStyle = styled(Box)`
  padding: 16px 0;
  display: flex;
  flex-direction: row;
  position: relative;
`

const HeaderCard = styled(Box)`
  display: flex;
  margin-bottom: 8px;
`

const IconFeed = styled(Box)`
  margin-right: 14px;
  max-width: 24px;
  max-height: 24px;
  width: 100%;
  height: 100%;
`

const CardContentFeed = ({ children: childrenProp, icon, ...props }) => {
  const [summary, ...children] = React.Children.toArray(childrenProp)

  return (
    <CardContentFeedStyle {...props}>
      <IconFeed>{icon}</IconFeed>
      <Box>
        <HeaderCard as="div">{summary}</HeaderCard>
        {children}
      </Box>
    </CardContentFeedStyle>
  )
}

export { CardContentFeed }
